import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const ListingViewMainHolder = styled.main`
  flex: 1;
  padding-top: 32px;

  /* The compact header's grey listing summary sits flush under the site header.
     Expired pages render ListingViewExpiredTag above that header, so they keep
     the padding or the notice would end up flush instead */
  &:has([data-mobile-compact]):not(:has([data-listing-expired-tag])) {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      padding-top: 0;
    }
  }
`;
